import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'utcToLocal',
  standalone: true,
})
export class UtcToLocalPipe implements PipeTransform {
  transform(value: string | Date | null, format: string = 'medium'): string {
    if (!value) return '';

    let date: Date;

    if (typeof value === 'string') {
      const normalized = value.endsWith('Z') || value.includes('+') ? value : value + 'Z';
      date = new Date(normalized);
    } else {
      date = value;
    }

    return new Intl.DateTimeFormat(undefined, this.getOptions(format)).format(date);
  }

  private getOptions(format: string): Intl.DateTimeFormatOptions {
    switch (format) {
      case 'shortTime':
        return { hour: '2-digit', minute: '2-digit' };
      case 'mediumDate':
        return { year: 'numeric', month: 'short', day: 'numeric' };
      case 'full':
        return { dateStyle: 'full', timeStyle: 'short' };
      default:
        return { dateStyle: 'medium', timeStyle: 'short' };
    }
  }
}